import React, { useState } from "react";
import Card from "../../../components/ui/Card";
import Button from "../../../components/ui/Button";
import Input from "../../../components/ui/Input";
import { User, Mail, MapPin, Calendar, Save } from "lucide-react";
import ImageUpload from "../../../components/ui/ImageUpload";

const ProfileEditPage = () => {
  const [profile, setProfile] = useState({
    name: "Abebe Tesfaye",
    email: "abebe.t@email.com",
    location: "Addis Ababa, Ethiopia",
    bio: "Music lover and tech enthusiast",
    joinDate: "January 2024"
  });

  const handleSave = () => {
    alert("Profile updated successfully!");
  };

  return (
    <div className="min-h-screen bg-slate-50 p-4">
      <div className="max-w-2xl mx-auto">
        <h1 className="text-2xl font-bold text-slate-800 mb-6">Edit Profile</h1>

        <Card className="p-6 space-y-6">
          {/* Profile Picture */}
          <div>
            <label className="block text-sm font-semibold text-slate-700 mb-2">
              Profile Picture
            </label>
            <div className="flex items-center space-x-4">
              <div className="w-32">
                <ImageUpload
                  aspectRatio="square"
                  onUpload={(file, url) =>
                    setProfile({ ...profile, profilePic: url })
                  }
                  currentImage={profile.profilePic}
                />
              </div>
              <div className="text-sm text-slate-500">
                <p>Recommended: 400x400px</p>
                <p>JPG, PNG up to 2MB</p>
              </div>
            </div>
          </div>

          {/* Name */}
          <div>
            <label className="block text-sm font-semibold text-slate-700 mb-2">
              <User size={16} className="inline mr-1" />
              Full Name
            </label>
            <Input
              value={profile.name}
              onChange={(e) => setProfile({ ...profile, name: e.target.value })}
            />
          </div>

          {/* Email */}
          <div>
            <label className="block text-sm font-semibold text-slate-700 mb-2">
              <Mail size={16} className="inline mr-1" />
              Email
            </label>
            <Input
              type="email"
              value={profile.email}
              onChange={(e) => setProfile({ ...profile, email: e.target.value })}
            />
          </div>

          {/* Location */}
          <div>
            <label className="block text-sm font-semibold text-slate-700 mb-2">
              <MapPin size={16} className="inline mr-1" />
              Location
            </label>
            <Input
              value={profile.location}
              onChange={(e) => setProfile({ ...profile, location: e.target.value })}
            />
          </div>

          {/* Bio */}
          <div>
            <label className="block text-sm font-semibold text-slate-700 mb-2">
              Bio
            </label>
            <textarea
              value={profile.bio}
              onChange={(e) => setProfile({ ...profile, bio: e.target.value })}
              className="w-full p-3 border border-slate-300 rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-primary"
              rows="4"
            />
          </div>

          {/* Join Date (Read-only) */}
          <div>
            <label className="block text-sm font-semibold text-slate-700 mb-2">
              <Calendar size={16} className="inline mr-1" />
              Member Since
            </label>
            <Input value={profile.joinDate} disabled />
          </div>

          {/* Save Button */}
          <Button onClick={handleSave} className="w-full">
            <Save size={18} className="mr-2" />
            Save Changes
          </Button>
        </Card>
      </div>
    </div>
  );
};

export default ProfileEditPage;
